// src/components/UploadModal.js
import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from '@chakra-ui/react';
import FileUploader from './FileUploader';

const UploadModal = ({ isOpen, onClose, onUploadSuccess, productId }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent maxWidth="70vw">
        <ModalHeader>بارگذاری فایل‌ها</ModalHeader>
        <ModalCloseButton position="absolute" left="8px" right="auto" />
        <ModalBody>
          <FileUploader onClose={onClose} onUploadSuccess={onUploadSuccess} productId={productId}  />
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            بستن
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default UploadModal;
